/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_TitleInputs */

const en_tools_title = /** @type {(inputs: Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Tools Ranking`)
};

const id_tools_title = /** @type {(inputs: Tools_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ranking AI Tools`)
};

/**
* | output |
* | --- |
* | "AI Tools Ranking" |
*
* @param {Tools_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tools_title = /** @type {((inputs?: Tools_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tools_title(inputs)
	return en_tools_title(inputs)
});